import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import LoginContainer from '../components/login/loginContainer';
import { RootState } from '../store/store';

/**
 * Login Page - Displays the login/signup dialog
 */
export default function LoginPage() {
  const navigate = useNavigate();
  const { isAuthenticated, initialized } = useSelector((state: RootState) => state.auth);

  React.useEffect(() => {
    if (!initialized || !isAuthenticated) return;
    const redirectTo = localStorage.getItem('crowdtrades_post_login_redirect');
    if (redirectTo) {
      localStorage.removeItem('crowdtrades_post_login_redirect');
      navigate(redirectTo);
      return;
    }
    navigate('/');
  }, [initialized, isAuthenticated, navigate]);

  const handleClose = () => {
    navigate('/');
  };

  return (
    <Box sx={{ minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <LoginContainer open={true} onClose={handleClose} />
    </Box>
  );
}
